import styled from 'styled-components';
import { Select as AntSelect } from 'antd';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseInput as BaseInputDefault } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BORDER_RADIUS } from '@app/styles/themes/constants';

export const BodyWrapper = styled.div`
  padding: 24px 24px 12px 24px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerWrapper = styled.div`
  margin-top: 24px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const IconButton = styled.button`
  border: 0;
  background: none;
  cursor: pointer;
  color: var(--text-dark-color);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .anticon {
    font-size: 16px;
  }
`;

export const DeleteIconButton = styled(IconButton)`
  color: var(--error-color);
`;

export const AddingButtonWrapper = styled.button`
  border: 0;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  color: var(--primary-color);

  .anticon {
    margin-right: 8px;
  }
`;

export const AddingButtonText = styled.div``;

export const BaseInput = styled(BaseInputDefault)`
  && {
    color: var(--text-dark-color);
    background-color: var(--highlighting-dark-color);
    border: none;
    border-radius: ${BORDER_RADIUS};
  }
`;

export const TypeSelect = styled(AntSelect)`
  && {
    width: 100%;
    min-width: 120px;

    .ant-select-selector {
      color: var(--text-dark-color);
      background-color: var(--highlighting-dark-color);
      border: none;
      border-radius: ${BORDER_RADIUS};
    }

    .ant-select-selection-placeholder {
      color: var(--subtext-color);
    }
  }
`;

export const FooterWrapper = styled.div`
  padding: 0;
`;

export const FooterButton = styled(BaseButton)`
  min-width: 190px;
`;
